import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';
import { SocialBar } from '../common/SocialIcons';
import { SOCIAL, WHATSAPP_LINK, WHATSAPP_DISPLAY } from '../../utils/constants';

export default function Footer() {
  const links = [
    { name: 'Home', path: '/' }, { name: 'Books', path: '/books' }, { name: 'Poets', path: '/poets' },
    { name: 'Articles', path: '/articles' }, { name: 'Gallery', path: '/gallery' }, { name: 'News & Events', path: '/news' }, { name: 'Contact', path: '/contact' },
  ];
  return (
    <footer style={{ background: 'var(--dark)', color: 'rgba(255,255,255,.7)', padding: '60px 40px 30px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 40, maxWidth: 1200, margin: '0 auto' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <Logo size={36} /><span className="serif" style={{ fontSize: '1.4rem', fontWeight: 700, color: 'white' }}>Wijdan</span>
          </div>
          <p style={{ fontSize: 14, lineHeight: 1.7 }}>Sufism · Literature · Art · Culture</p>
          <div style={{ marginTop: 16 }}><SocialBar dark /></div>
        </div>
        <div>
          <h4 style={{ color: 'var(--saffron-light)', fontFamily: "'Cormorant Garamond',serif", fontSize: '1.3rem', marginBottom: 16 }}>Quick Links</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {links.map(l => <Link key={l.path} to={l.path} style={{ color: 'rgba(255,255,255,.7)', transition: 'color .2s' }}>{l.name}</Link>)}
          </div>
        </div>
        <div>
          <h4 style={{ color: 'var(--saffron-light)', fontFamily: "'Cormorant Garamond',serif", fontSize: '1.3rem', marginBottom: 16 }}>Contact</h4>
          <p style={{ marginBottom: 8 }}>WhatsApp: {WHATSAPP_DISPLAY}</p>
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" style={{ color: '#25D366', fontWeight: 500 }}>Chat on WhatsApp →</a>
        </div>
        <div>
          <h4 style={{ color: 'var(--saffron-light)', fontFamily: "'Cormorant Garamond',serif", fontSize: '1.3rem', marginBottom: 16 }}>Watch Live</h4>
          <p style={{ marginBottom: 12 }}>Tune in to live Sufi music and poetry sessions.</p>
          <a href={SOCIAL.youtube + '/live'} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '10px 20px', background: '#DC2626', color: 'white', borderRadius: 20, fontWeight: 600, fontSize: 14 }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'white', animation: 'livePulse 1.5s infinite', display: 'inline-block' }} /> Watch Live
          </a>
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: 40, paddingTop: 20, borderTop: '1px solid rgba(255,255,255,.08)', fontSize: 13 }}>
        © 2026 Wijjdan. All rights reserved. | <Link to="/admin" style={{ opacity: .3 }}>Admin</Link>
      </div>
    </footer>
  );
}
